module.exports = __webpack_public_path__ + "static/12-e3dffe2a3ac5effa4ce12c58fd0951e6.png";